package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_12_07_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes continue on their path. Around the time they would be seeking a camping site, they come upon a Malusian army camp site.  The heroes chat with the Malusian army. The small army camp is staying back while the rest are helping out in Brij-city. According to the army, there is some unknown issue with the local noble (the heroes are fully aware of this situation but feign surprise).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes brainstorm ideas about a good cover story. Perhaps they are big game hunters, hired by some elites to recover trophies of dangerous monsters.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes observe patrols traveling in both the Malus and Brij-city directions. No patrols heading North toward the Brij Bridge.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A human female calvary officer approaches the heroes’ camp. She identifies herself as Corporal Dander. She is delivering a map of Vor’s desert to the heroes on orders of Sergeant Perry.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette observes that the Malusian camp lacks advanced artillery or technology that she traded in in a former life.")
    }
}
